import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './login.css';
import * as config from '../config';

function SignUp() {
  const [passwordInfo, setPasswordInfo] = useState({
    password: '',
    confirmPassword: '',
    login_id: '',
    error_message: '',
  });

  const navigate = useNavigate();
  const login_id = localStorage.getItem('login_id');

  useEffect(() => {
    if (login_id === null) {
      navigate('/');
    }
  }, [login_id]);

  const handlePasswordChange = () => {
    // Add password validation logic here
    if (passwordInfo.password !== passwordInfo.confirmPassword) {
      setPasswordInfo({ ...passwordInfo, error_message: 'Passwords do not match' });
      return;
    }

    // Use Axios for the API call
    axios
      .put(`${config.DevelopmentUri}/api/login/${login_id}`, { password: passwordInfo.password })
      .then(response => {
        const data = response.data;
        if (data.success) {
          navigate('/report');
        } else {
          setPasswordInfo({ ...passwordInfo, error_message: 'Error updating password' });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        setPasswordInfo({ ...passwordInfo, error_message: 'An error occurred' });
      });
  };

  return (
    <div className="background">
      <div className="signcontainer">
        <h1>Change Your Password</h1>
        <div className="input">
          <input
            type="password"
            placeholder="Enter Your New Password"
            value={passwordInfo.password}
            onChange={e => setPasswordInfo({ ...passwordInfo, password: e.target.value })}
          />
        </div>
        <div className="input">
          <input
            type="password"
            value={passwordInfo.confirmPassword}
            placeholder="Confirm Password"
            onChange={e => setPasswordInfo({ ...passwordInfo, confirmPassword: e.target.value })}
            required
          />
        </div>
        {passwordInfo.error_message && <div className="error-message">{passwordInfo.error_message}</div>}
        <button type="button" onClick={handlePasswordChange}>
         Update
        </button>
      </div>
    </div>
  );
}

export default SignUp;
